import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { blogPosts } from '../data/blogData';
const BlogPage = () => {
  const [activeCategory, setActiveCategory] = useState('All');
  const categories = ['All', 'Nutrition', 'Tips & Tricks', 'Challenges', 'Education', 'Health & Safety', 'Maternal Health'];
  const filteredPosts = activeCategory === 'All' ? blogPosts : blogPosts.filter(post => post.category === activeCategory);
  return <div className="bg-cream py-12" data-id="element-197">
      {/* Hero Section */}
      <section className="bg-beige py-16 mb-12" data-id="element-198">
        <div className="container mx-auto px-4 text-center" data-id="element-199">
          <h1 className="text-3xl md:text-4xl font-bold text-brown mb-4" data-id="element-200">
            Education Hub
          </h1>
          <p className="text-gray-700 max-w-2xl mx-auto" data-id="element-201">
            Explore our collection of articles, tips, and guides to help you
            navigate your baby's nutrition and care journey.
          </p>
        </div>
      </section>
      <div className="container mx-auto px-4" data-id="element-202">
        {/* Categories */}
        <div className="mb-8 overflow-x-auto" data-id="element-203">
          <div className="flex space-x-4 pb-2" data-id="element-204">
            {categories.map(category => <button key={category} className={`px-4 py-2 rounded-full ${activeCategory === category ? 'bg-brown text-white' : 'bg-white text-brown hover:bg-brown hover:text-white'} transition-colors duration-300 whitespace-nowrap`} onClick={() => setActiveCategory(category)} data-id="element-205">
                {category}
              </button>)}
          </div>
        </div>
        {/* Blog Posts */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-206">
          {filteredPosts.map(post => <div key={post.id} className="bg-white rounded-lg overflow-hidden shadow-md hover:shadow-lg transition-shadow duration-300" data-id="element-207">
              <Link to={`/blog/${post.id}`} data-id="element-208">
                <img src={post.imageUrl} alt={post.title} className="w-full h-48 object-cover" data-id="element-209" />
                <div className="p-6" data-id="element-210">
                  <div className="flex justify-between items-center mb-2" data-id="element-211">
                    <span className="text-sm text-brown bg-beige px-2 py-1 rounded-full" data-id="element-212">
                      {post.category}
                    </span>
                    <span className="text-sm text-gray-500" data-id="element-213">{post.date}</span>
                  </div>
                  <h3 className="text-xl font-bold text-brown mb-2" data-id="element-214">
                    {post.title}
                  </h3>
                  <p className="text-gray-600 mb-4" data-id="element-215">{post.excerpt}</p>
                  <span className="text-brown font-medium hover:text-brown-dark" data-id="element-216">
                    Read more →
                  </span>
                </div>
              </Link>
            </div>)}
        </div>
        {/* Newsletter */}
        <div className="mt-16 bg-beige p-8 rounded-lg" data-id="element-217">
          <div className="text-center" data-id="element-218">
            <h2 className="text-2xl font-bold text-brown mb-4" data-id="element-219">
              Subscribe to Our Newsletter
            </h2>
            <p className="text-gray-700 mb-6 max-w-2xl mx-auto" data-id="element-220">
              Get the latest articles, tips, and resources delivered directly to
              your inbox.
            </p>
            <form className="max-w-md mx-auto" data-id="element-221">
              <div className="flex flex-col sm:flex-row gap-2" data-id="element-222">
                <input type="email" placeholder="Your email address" className="flex-grow px-4 py-3 rounded-full focus:outline-none focus:ring-2 focus:ring-brown" data-id="element-223" />
                <button type="submit" className="bg-brown text-cream px-6 py-3 rounded-full hover:bg-brown-dark transition-colors duration-300" data-id="element-224">
                  Subscribe
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>;
};
export default BlogPage;